/* ============================================================
   LSF Collection Page — lsf-collection.js
   Drop into: assets/lsf-collection.js
   Then add before </body> in theme.liquid:
   <script src="{{ 'lsf-collection.js' | asset_url }}" defer></script>
   ============================================================ */

$(document).ready(function () {
    $('.lsf-slick-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,

        swipe: true,
        touchMove: true,
        draggable: true,
        accessibility: true,

        prevArrow: '<button type="button" class="lsf-arrow lsf-arrow--prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 4L6 8L10 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',

        nextArrow: '<button type="button" class="lsf-arrow lsf-arrow--next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const button = document.getElementById("lsf-load-more");
    if (!button) return;

    button.addEventListener("click", loadMoreProducts);

    function loadMoreProducts() {
        const nextUrl = button.dataset.nextUrl;
        if (!nextUrl) return;

        button.disabled = true;
        button.classList.add("loading");

        fetch(nextUrl)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                const grid = document.querySelector("#lsf-product-grid");
                const loadMoreWrapper = grid.querySelector(".lsf-load-more-wrapper");
                const newCards = doc.querySelectorAll("#lsf-product-grid .lsf-card");

                // Insert new products before the Load More wrapper
                newCards.forEach(function (card) {
                    grid.insertBefore(card, loadMoreWrapper);
                });

                // Update shown product count
                const shownProducts = grid.querySelectorAll(".lsf-card").length;
                const shownCount = document.getElementById("shown-products");

                if (shownCount) {
                    shownCount.textContent = shownProducts;
                }

                // Update next page URL or remove button if last page
                const nextButton = doc.querySelector("#lsf-load-more");

                if (nextButton) {
                    button.dataset.nextUrl = nextButton.dataset.nextUrl;
                    button.disabled = false;
                    button.classList.remove("loading");
                } else {
                    const wrapper = document.querySelector(".lsf-load-more-wrapper");
                    if (wrapper) {
                        wrapper.remove();
                    } else {
                        button.remove();
                    }
                }

                // Initialize Slick for newly added sliders only
                if (window.jQuery && typeof jQuery.fn.slick === "function") {
                    jQuery(newCards)
                        .find(".lsf-slick-slider")
                        .each(function () {
                            if (!jQuery(this).hasClass("slick-initialized")) {
                                jQuery(this).slick({
                                    arrows: false,
                                    dots: true,
                                    infinite: false
                                });
                            }
                        });
                }
            })
            .catch(function (error) {
                console.error("Load More Error:", error);
                button.disabled = false;
                button.classList.remove("loading");
            });
    }
});

(function () {
  "use strict";

  /* ── Element refs ──────────────────────────────────────── */
  const drawer = document.getElementById("lsf-filter-drawer");
  const overlay = document.getElementById("lsf-filter-overlay");
  const closeBtn = document.getElementById("lsf-filter-close");
  const openBtns = document.querySelectorAll("[data-lsf-filter-open]");

  if (!drawer) return;

  /* ── Open / Close helpers ──────────────────────────────── */
  function openDrawer() {
    drawer.classList.add("is-open");

    if (overlay) {
      overlay.classList.add("is-open");
    }

    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";

    if (closeBtn) {
      closeBtn.focus();
    }
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");

    if (overlay) {
      overlay.classList.remove("is-open");
    }

    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";

    const trigger = document.querySelector("[data-lsf-filter-open]");
    if (trigger) {
      trigger.focus();
    }
  }

  /* ── Open buttons ──────────────────────────────────────── */
  openBtns.forEach((btn) => {
    btn.addEventListener("click", openDrawer);
  });

  /* ── Close ─────────────────────────────────────────────── */
  if (closeBtn) {
    closeBtn.addEventListener("click", closeDrawer);
  }

  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }

  /* Escape */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  /* ── Collapsible filter groups ─────────────────────────── */
  const toggles = drawer.querySelectorAll(".lsf-filter-group__toggle");

  toggles.forEach(function (toggle) {
    const contentId = toggle.getAttribute("aria-controls");
    const content = document.getElementById(contentId);

    if (!content) return;

    toggle.setAttribute("aria-expanded", "false");
    content.hidden = true;

    toggle.addEventListener("click", function () {
      const expanded = toggle.getAttribute("aria-expanded") === "true";

      toggle.setAttribute("aria-expanded", String(!expanded));

      content.hidden = expanded;
    });
  });

  /* ── NEW PRICE RANGE DUAL SLIDER ───────────────────────── */

  const wrap = drawer.querySelector("[data-price-range]");

  if (wrap) {
    const minInput = wrap.querySelector('[data-price-input="min"]');
    const maxInput = wrap.querySelector('[data-price-input="max"]');

    const minRange = wrap.querySelector('[data-range="min"]');
    const maxRange = wrap.querySelector('[data-range="max"]');

    const fill = wrap.querySelector("[data-price-fill]");

    if (minInput && maxInput && minRange && maxRange && fill) {
      const rangeMax = parseFloat(maxRange.max);

      function updateFill() {
        const min = parseFloat(minRange.value);

        const max = parseFloat(maxRange.value);

        const minPercent = (min / rangeMax) * 100;

        const maxPercent = (max / rangeMax) * 100;

        fill.style.left = minPercent + "%";

        fill.style.width = maxPercent - minPercent + "%";
      }

      /* Min slider */

      minRange.addEventListener("input", function () {
        let value = Math.min(
          parseFloat(minRange.value),
          parseFloat(maxRange.value) - 1,
        );

        minRange.value = value;
        minInput.value = value;

        updateFill();
      });

      /* Max slider */

      maxRange.addEventListener("input", function () {
        let value = Math.max(
          parseFloat(maxRange.value),
          parseFloat(minRange.value) + 1,
        );

        maxRange.value = value;
        maxInput.value = value;

        updateFill();
      });

      /* Min input */

      minInput.addEventListener("change", function () {
        let value = Math.max(
          0,
          Math.min(parseFloat(minInput.value), parseFloat(maxInput.value) - 1),
        );

        if (isNaN(value)) {
          value = 0;
        }

        minInput.value = value;
        minRange.value = value;

        updateFill();
      });

      /* Max input */

      maxInput.addEventListener("change", function () {
        let value = Math.min(
          rangeMax,
          Math.max(parseFloat(maxInput.value), parseFloat(minInput.value) + 1),
        );

        if (isNaN(value)) {
          value = rangeMax;
        }

        maxInput.value = value;
        maxRange.value = value;

        updateFill();
      });

      updateFill();
    }
  }
})();


// If no filter select to disabled clearall and applybtn
document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("lsf-filter-form");
  const applyBtn = document.getElementById("lsf-apply-btn");
  const clearBtn = document.getElementById("lsf-clear-btn");

  const minInput = document.getElementById("lsf-price-min");
  const maxInput = document.getElementById("lsf-price-max");

  function updateButtons() {
    let hasFilters = false;

    // Check checkboxes
    if (form.querySelector('input[type="checkbox"]:checked')) {
      hasFilters = true;
    }

    // Check price range
    if (!hasFilters && minInput && maxInput) {
      const defaultMin = Number(minInput.placeholder);
      const defaultMax = Number(maxInput.placeholder);

      const currentMin = Number(minInput.value || defaultMin);
      const currentMax = Number(maxInput.value || defaultMax);

      if (currentMin !== defaultMin || currentMax !== defaultMax) {
        hasFilters = true;
      }
    }

    applyBtn.disabled = !hasFilters;

    if (hasFilters) {
      clearBtn.classList.remove("is-disabled");
      clearBtn.removeAttribute("aria-disabled");
    } else {
      clearBtn.classList.add("is-disabled");
      clearBtn.setAttribute("aria-disabled", "true");
    }
  }

  form.addEventListener("change", updateButtons);
  form.addEventListener("input", updateButtons);

  clearBtn.addEventListener("click", function (e) {
    if (this.classList.contains("is-disabled")) {
      e.preventDefault();
    }
  });

  updateButtons();
});
// If no filter select to disabled clearall and applybtn end

// in collection page sorting filter popup
const btn = document.getElementById('sortBtn');
const popup = document.getElementById('sortPopup');

btn.addEventListener('click', function(e) {
  e.stopPropagation();
  popup.classList.toggle('show');
});

document.addEventListener('click', function() {
  popup.classList.remove('show');
});
// in collection page sorting filter popup end

// Scroll to add class in filter
$(window).on("scroll", function () {
    var scroll = $(this).scrollTop();

    var announcementbarHeight = $('#shopify-section-custom-announcement-bar').outerHeight() || 0;
    var headerHeight = $('#shopify-section-custom-pdp-header').outerHeight() || 0;

    var extraOffset = $(window).width() <= 575 ? 0 : 20;
    var topOffset = announcementbarHeight + headerHeight + extraOffset;

    if (scroll <= 150) {
        $(".lsf-toolbar__right")
            .removeClass("sticky")
            .css("top", "");
    } else {
        $(".lsf-toolbar__right")
            .addClass("sticky")
            .css("top", topOffset + "px");
    }
});

// lsf-recommended__grid get random product and slider
// document.addEventListener('DOMContentLoaded', function () {

//     const $slider = $('.js-random-recommended');

//     if (!$slider.length) return;

//     // Get all cards
//     let cards = $slider.children('.lsf-card').toArray();

//     // Fisher-Yates Shuffle
//     for (let i = cards.length - 1; i > 0; i--) {
//         const j = Math.floor(Math.random() * (i + 1));
//         [cards[i], cards[j]] = [cards[j], cards[i]];
//     }

//     // Keep first 10 cards
//     cards = cards.slice(0, 10);

//     $slider.empty();

//     cards.forEach(function (card) {
//         $slider.append(card);
//     });

//     // Function to position arrows
//     function setArrowPosition() {
//         var divHeight = $slider.find('.lsf-card__info').first().outerHeight();

//         if (divHeight) {
//             $slider.find('.custom-arrow').css('top', `calc(50% - ${(divHeight / 2)}px)`);
//         }
//     }

//     // Run after Slick is initialized
//     $slider.on('init', function () {
//         setArrowPosition();
//     });

//     // Initialize Slick
//     $slider.slick({
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         infinite: true,
//         arrows: true,
//         dots: true,
//         autoplay: false,
//         speed: 500,

//         prevArrow: `
//             <button type="button" class="slick-prev custom-arrow" aria-label="Previous">
//                 <svg width="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path d="M10 4L6 8L10 12" stroke="#3B3A3B" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>
//             </button>
//         `,

//         nextArrow: `
//             <button type="button" class="slick-next custom-arrow" aria-label="Next">
//                 <svg width="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path d="M6 4.5L10 8.5L6 12.5" stroke="#3B3A3B" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>
//             </button>
//         `,

//         responsive: [
//             {
//                 breakpoint: 1200,
//                 settings: {
//                     slidesToShow: 4
//                 }
//             },
//             {
//                 breakpoint: 990,
//                 settings: {
//                     slidesToShow: 3
//                 }
//             },
//             {
//                 breakpoint: 640,
//                 settings: {
//                     slidesToShow: 2,
//                     arrows: false,
//                 }
//             }
//         ]
//     });

//     // Recalculate on window resize
//     $(window).on('resize', function () {
//         setArrowPosition();
//     });

// });


document.addEventListener('DOMContentLoaded', function () {
    const $slider = $('.js-random-recommended');
    if (!$slider.length) return;

    // Keep server-rendered order (best sellers), just cap at 10 cards
    let cards = $slider.children('.lsf-card').toArray().slice(0, 10);
    $slider.empty();
    cards.forEach(function (card) {
        $slider.append(card);
    });

    // Function to position arrows
    function setArrowPosition() {
        var divHeight = $slider.find('.lsf-card__info').first().outerHeight();
        if (divHeight) {
            $slider.find('.custom-arrow').css('top', `calc(50% - ${(divHeight / 2)}px)`);
        }
    }

    // Run after Slick is initialized
    $slider.on('init', function () {
        setArrowPosition();
    });

    // Initialize Slick
    $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        draggable: false,
        autoplay: false,
        speed: 500,
        prevArrow: `
            <button type="button" class="slick-prev custom-arrow" aria-label="Previous">
                <svg width="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 4L6 8L10 12" stroke="#3B3A3B" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        `,
        nextArrow: `
            <button type="button" class="slick-next custom-arrow" aria-label="Next">
                <svg width="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 4.5L10 8.5L6 12.5" stroke="#3B3A3B" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        `,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 4 } },
            { breakpoint: 990, settings: { slidesToShow: 3 } },
            { breakpoint: 640, settings: { slidesToShow: 2, arrows: false } }
        ]
    });

    $(window).on('resize', function () {
        setArrowPosition();
    });
});
// lsf-recommended__grid get random product and slider end